import styled from "styled-components";
import { 
  Typography 
} from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import Avatar from '@material-ui/core/Avatar';

export const Title = styled(Typography)`
 text-align: center;
 color: white !important;
 padding-top: 15px !important;`


export const Container = styled.div`
 width:  280px;
 position: relative;`
 
export const Rating = styled(Typography)`
 margin-left: 5px !important;
 margin-top: 5px !important;
 color: white !important;`

 export const Star = styled(StarIcon)`
  fill: gold !important;`

   export const StyledAvatar = styled(Avatar)`
    width:100px !important;
    height: 100px !important;
    border-radius: 50% !important;
    background-size: contain !important;
    background-position: center !important;
    cursor: pointer !important;
    border: 2px solid #dcbb1c !important;
    padding: 5px !important;`
 

// .bigContainer { 
// position: relative;
//  width:  400px; 
//  height: 600px;
//  margin-top: -40px;
// }


// .rating {
//     margin-left: 52px;
// }

// .ratingCat {
//     margin-left: 0px;
// }

// .image {
//  width:  280px; 
//  height: 450px;
// }

// .bigImage {
// width:  400px; 
//  height: 600px;
// }



// .authorWrapper {
//     display: flex;
//     align-items: center;
// }

// .authorImg {
//     margin-right: 10px;
//     margin-top: -5px;
// }


// .rateWrapper {
//     display: flex;
//     align-items: center;
//     justify-content: flex-start;
// }